import { NeCloudFileIcon } from '@eastcoal/icon/NeCloudFileIcon'
import { NeExcelIcon } from '@eastcoal/icon/NeExcelIcon'
import { NeImageIcon } from '@eastcoal/icon/NeImageIcon'
import { NePdfIcon } from '@eastcoal/icon/NePdfIcon'
import { NePowerPointIcon } from '@eastcoal/icon/NePowerPointIcon'
import { NeWordIcon } from '@eastcoal/icon/NeWordIcon'

export const isWord = (mimeType?: string) => {
  return (
    mimeType?.includes('msword') ||
    mimeType?.includes('ms-word') ||
    mimeType?.includes('officedocument')
  )
}

export const isExcel = (mimeType?: string) => {
  return mimeType?.includes('excel') || mimeType?.includes('spreadsheetml')
}

export const isPdf = (mimeType?: string) => {
  return mimeType?.includes('pdf')
}

export const isPPT = (mimeType?: string) => {
  return mimeType?.includes('powerpoint') || mimeType?.includes('presentation')
}

export const isOfficeFile = (mimeType?: string) => {
  return (
    isWord(mimeType) || isExcel(mimeType) || isPdf(mimeType) || isPPT(mimeType)
  )
}

export const isZip = (mimeType?: string) => {
  return (
    mimeType?.includes('zip') ||
    mimeType?.includes('rar') ||
    mimeType?.includes('7z')
  )
}

export const isImage = (mimeType?: string) => {
  return mimeType?.startsWith('image/')
}

export const isVideo = (mimeType?: string) => {
  return mimeType?.startsWith('video/')
}

export const isAudio = (mimeType?: string) => {
  return mimeType?.startsWith('audio/')
}

export const getIconByMimeType = (mimeType?: string) => {
  if (isImage(mimeType)) {
    return NeImageIcon
  } else if (isWord(mimeType)) {
    return NeWordIcon
  } else if (isExcel(mimeType)) {
    return NeExcelIcon
  } else if (isPdf(mimeType)) {
    return NePdfIcon
  } else if (isPPT(mimeType)) {
    return NePowerPointIcon
  } else {
    return NeCloudFileIcon
  }
}
